import { getCurrentInstance ,reactive} from 'vue';
import { useStore } from "vuex";
import { useMQTT } from 'mqtt-vue-hook'
import { MQTTCommand, MQTTTempCommand, MQTTDooyaRonoCommand, MQTTDooyaRonoAction, DeviceType } from '../constants';

export default function useMqttControl() {  
   
  const store = useStore();
  const { mqtt,mobile ,logger} = getCurrentInstance().appContext.config.globalProperties;
  const mqttHook = mqtt.getMqttHook();

  const registMcsEvent = (topic,message) => {
    let data = JSON.parse(message.toString())
    switch(data.cmd){
      case MQTTCommand.SettingMode:
        store.dispatch("home/changeDeviceSettingMode",data)
        break;
      case MQTTCommand.StateChanged:
      case MQTTCommand.Control:
        store.dispatch("home/changeDeviceState",data)
        break;
      case MQTTCommand.FirmwareUpdateStarted:
      case MQTTCommand.FirmwareUpdateFinished:
        store.dispatch("home/changeControllerFirmwareUpdateState",data)
        break;         
      case MQTTCommand.Version:
        store.dispatch("home/updateControllerFirmwareVersion",data)
        break;     
      case MQTTCommand.Ping:
        store.dispatch("home/updateCheckControllers", { ...data, value: 1 })
        break;
      case MQTTCommand.ControlPower:
        store.dispatch("home/changeDevicesPower",data)
        break;
      case MQTTCommand.ControlSetting:
        store.dispatch("home/changeDevicesState",data)
        break;
      case MQTTCommand.VirtualControl:
        store.dispatch("home/changeVirtualDeviceState",data)
        break;
      case MQTTCommand.VirtualSwitchControl:
        store.dispatch("home/changeVirtualSwitchControl",data)
        break;
      case MQTTCommand.VirtualSwitchSetting:
        store.dispatch("home/changeVirtualSwitchSetting",data)
        break;
      case MQTTCommand.VirtualBoundControl:
        store.dispatch("home/changeVirtualBoundControl",data)
        break;
      case MQTTDooyaRonoCommand.DooyaRegisterRequest:
        store.dispatch("home/dooyaRegisterRequest",data);
        break;
      case MQTTDooyaRonoCommand.DooyaAck:
        console.log(`data : ${data.cmd} ${data.req_cmd}`)
        if (data.req_cmd == MQTTDooyaRonoCommand.DooyaAddr) {
          store.dispatch("home/dooyaAddressAck",data);
        } else if (data.req_cmd == MQTTDooyaRonoCommand.DooyaCtrl && data.data?.action == MQTTDooyaRonoAction.Direction) {
          store.dispatch("home/dooyaDirectionAck", data);
        }
        break;
      case MQTTDooyaRonoCommand.RonoRegisterRequest:
        store.dispatch("home/ronoRegisterRequest",data);
        break;
      case MQTTDooyaRonoCommand.RonoAck:
        console.log(`data : ${data.cmd} ${data.req_cmd}`)
        if (data.req_cmd == MQTTDooyaRonoCommand.RonoAddr) {
          store.dispatch("home/ronoAddressAck",data);
        } else if (data.req_cmd == MQTTDooyaRonoCommand.RonoCtrl && data.data?.action == MQTTDooyaRonoAction.Direction) {
          store.dispatch("home/ronoDirectionAck", data);
        }
        break;
    }
  }
  const registZoneEvent = (topic,message) => {
    const arrTopics = topic.split('/')
    const zoneId = arrTopics[3]
    const payload = JSON.parse(message.toString())
    console.log(`[mqtt] subscribe received => zoneId : ${zoneId},payload : ${message.toString()}`)

    const zone = store.getters['home/getZones'].find(z => z._id === parseInt(zoneId))
    if(zone){
      console.log(`[mqtt] subscribe received => zone : ${zone.name},payload : ${message.toString()}`)
      if(payload.isEditMode){
        mobile.showSnackBar(`영역[${zone.name}]이 설정 상태로 변경되었습니다.`)
      }else{
        mobile.showSnackBar(`영역[${zone.name}]이 설정이 완료되었습니다.`)
      }
    }            

    store.dispatch("home/changeZoneEditMode",{...payload,zoneId:parseInt(zoneId)})    
  }
  const registStatEvent = (topic,message) => {
    try {
      const splittedTopics = topic.split("/");
      if (splittedTopics.length < 4) {
        return;
      }
  
      const controllerId = splittedTopics[2];
      const command = splittedTopics[3];
      if (command == "TIMERGROUPENABLE") {
        store.dispatch("home/updateCheckControllers", { serial: controllerId, value: 1 });
        return;
      }

      const messageText = message?.toString?.() ?? `${message}`;
      let parsedValue;
      if (messageText.startsWith("{")) {
        parsedValue = JSON.parse(messageText);
      } else if (command === MQTTTempCommand.PowerRl) {
        parsedValue = messageText;
      } else {
        return;
      }

      const data = {
        command: command,
        controllerId: controllerId,
        value: parsedValue,
      };

      if (command == "UPGRADE") {
        store.commit("home/setUpgradeTempController", data);
        return;
      }

      store.dispatch("home/chanageTempDeviceState",data);
    } catch(e) {
      console.log(e);
    }
  }
  const registCmndEvent = (topic,message) => {
    console.log(topic,message)
  }

  const syncControllerDevices = async (topics) => {
    for (const topic of topics){
      if (topic.includes('mcs')) {
        const splittedTopic = topic.split("/");
        if (splittedTopic.length === 6) {
          store.commit("home/setIsSyncControllerDevices", true);
          console.log(`useMqttControl.subscribe => splittedTopic : ${splittedTopic}, q`)
          onPublishController(splittedTopic[3], {
            serial: splittedTopic[3],
            cmd: "q",
            type: 1
          });
        }
      }
    }
  }

  const syncBoilerAwayModes = () => {
    if (process.env.VUE_APP_ENABLE_TEMP_CONTROLLER !== 'true') {
      return;
    }

    const controllerIds = new Set();
    store.getters['home/getZones']?.forEach((zone) => {
      zone.groups?.forEach((group) => {
        group.devices?.forEach((device) => {
          if (device.type === DeviceType.Boiler && device.controllerId && !device.isVirtual) {
            controllerIds.add(device.controllerId);
          }
        });
      });
    });

    controllerIds.forEach((controllerId) => {
      // Empty payload = stat only (must not use onPublishTemp; '' is inverted to '1').
      mqtt.publishAuth(`cmnd/inshow/${controllerId}/${MQTTTempCommand.AwayModeSet}`, '');
    });
  }

  const syncBoilerHcModes = () => {
    if (process.env.VUE_APP_ENABLE_TEMP_CONTROLLER !== 'true') {
      return;
    }

    const controllerIds = new Set();
    store.getters['home/getZones']?.forEach((zone) => {
      zone.groups?.forEach((group) => {
        group.devices?.forEach((device) => {
          if (device.type === DeviceType.Boiler && device.controllerId && !device.isVirtual) {
            controllerIds.add(device.controllerId);
          }
        });
      });
    });

    controllerIds.forEach((controllerId) => {
      onPublishTemp(controllerId, MQTTTempCommand.HcModeToggle, '');
      onPublishTemp(controllerId, MQTTTempCommand.AirconPower, '');
    });
  }

  const resyncBoilerModes = () => {
    syncBoilerHcModes();
    syncBoilerAwayModes();
  }

  const subscribe = async (topics) =>{
    return new Promise(async (resolve, reject) => {
      try {
        await mqtt.subscribe(topics);
        for (const topic of topics){          
          await mqttHook.unRegisterEvent(topic);
          await mqttHook.registerEvent(topic, (topic,message) =>{
            // console.log(`[mqtt] subscribe received => topic : ${topic},message : ${message.toString()}`)
            if (topic.includes('mcs')) {     
              registMcsEvent(topic, message);
            } else if (topic.includes('zone')) {                     
              registZoneEvent(topic, message);
            } else if (topic.includes('stat')) {                     
              registStatEvent(topic, message);
            }
          });
        }

        if (!store.getters['home/getIsSyncControllerDevices']) {
          syncControllerDevices(topics);
        }
        syncBoilerHcModes();
        syncBoilerAwayModes();
        resolve();
      } catch (e) {
        reject();
      }
    });
  }
  const unSubscribe = async (topics) =>{
    // console.log('useMqttControl.unSubscribe => topics : ',topics)
    // topics.forEach(async (topic) => {
    //   await mqtt.unSubscribe(topic)
    // })    

    console.log('unSubscribe => topics : ',topics)
    for(const topic of topics) {
      await mqtt.unSubscribe(topic)
    }
    return;
  }
  
  const onPublish = ((controllerId,deviceId,payload) =>{              
    console.log(`useMqttControl.onPublish => controllerId : ${controllerId},deviceId : ${deviceId},payload : ${payload}`)
    mqtt.publish(`${process.env.VUE_APP_MQTT_DEFAULT_TOPIC_PREFIX}/${process.env.VUE_APP_MQTT_MCS_TOPIC_PREFIX}/${controllerId}/${process.env.VUE_APP_MQTT_PUBLISH_TOPIC_SIRFIX}`, payload);
    store.dispatch("home/updateGroupDeviceState",{...payload,deviceId:deviceId}) 
  })
  const onPublishBatch = ((controllerId,deviceIds,payload,options) =>{              
    console.log(`useMqttControl.onPublishBatch => controllerId : ${controllerId},deviceIds : ${deviceIds},payload : ${JSON.stringify(payload)}`)
    mqtt.publish(`${process.env.VUE_APP_MQTT_DEFAULT_TOPIC_PREFIX}/${process.env.VUE_APP_MQTT_MCS_TOPIC_PREFIX}/${controllerId}/${process.env.VUE_APP_MQTT_PUBLISH_TOPIC_SIRFIX}`, payload);
    store.dispatch("home/updateGroupDevicesState", { ...(options ? { ...payload, data: { ...options } } : payload), deviceIds }) 
    
  })
  const onPublishZone = ((zoneId,payload) =>{              
    console.log(`useMqttControl.onPublishZone => zoneId : ${zoneId},payload : ${JSON.stringify(payload)}`)
    mqtt.publish(`${process.env.VUE_APP_MQTT_DEFAULT_TOPIC_PREFIX}/${process.env.VUE_APP_MQTT_ZONE_TOPIC_PREFIX}/${zoneId}/${process.env.VUE_APP_MQTT_PUBLISH_TOPIC_SIRFIX}`, payload);
    // store.dispatch("home/updateGroupDeviceState",{...payload,deviceId:deviceId}) 
  })

  const onPublishFirmware = (controllerId, payload)=> {    
    mqtt.publish(`${process.env.VUE_APP_MQTT_DEFAULT_TOPIC_PREFIX}/${process.env.VUE_APP_MQTT_MCS_TOPIC_PREFIX}/${controllerId}/${process.env.VUE_APP_MQTT_PUBLISH_TOPIC_SIRFIX}`, payload);
  }

  const onPublishController = (controllerId, payload)=> {    
    mqtt.publish(`${process.env.VUE_APP_MQTT_DEFAULT_TOPIC_PREFIX}/${process.env.VUE_APP_MQTT_MCS_TOPIC_PREFIX}/${controllerId}/${process.env.VUE_APP_MQTT_PUBLISH_TOPIC_SIRFIX}`, payload);
  }

  const onPublishTemp = (controllerId, command, payload)=> {
    if (command === MQTTTempCommand.AwayModeSet) {
      payload = payload == 0 ? '1' : '0';
    }
    if (typeof payload == 'number') {
      payload = `${payload}`;
    }
    if (typeof payload == "object") {
      payload = JSON.stringify(payload);
    }
    console.log(`cmnd/inshow/${controllerId}/${command}`, payload);
    mqtt.publishAuth(`cmnd/inshow/${controllerId}/${command}`, payload);
  }

  const registerEvent = (eventName,callback) =>{        
    mqttHook.registerEvent(eventName,callback)
  }

  const unRegisterEvent = (eventName) =>{
    mqttHook.unRegisterEvent(eventName)
  }

  const isConnected = () => {
    return mqttHook.isConnected()
  }
  const clearEvent = async() => {
    return await mqttHook.clearEvent()
  }
  const getMqttHook = () => {
    return mqttHook;
  }
  return {subscribe,unSubscribe,onPublish,onPublishBatch,onPublishZone,onPublishFirmware,onPublishController,onPublishTemp,registerEvent,unRegisterEvent,isConnected,clearEvent,getMqttHook,resyncBoilerModes}
}
